import { Accordion, Card } from "#/atoms";
import { FC, memo, useCallback, useState } from "react";

import { DESKTOP_SPACING } from "@/theme";
import { HeadingIcon } from "#/molecules";
import { LogoParams } from "@/api/order/interface";
import NewVirtualOrders from "./NewVirtualOrders";
import { ORDER_STATE } from "@/types";
import OrderServiceHeader from "./OrderServiceHeader";
import { PhotoProps } from "./OrderService.interface";
import PhotoUploader from "./PhotoUploader";
import PhotoWatermark from "./PhotoWatermark";
import Watermark from "./Watermark";
import { useNavigate } from "react-router-dom";

const Photo: FC<PhotoProps> = ({
  amount,
  branchId,
  draftFiles,
  hasLogo,
  isAdmin,
  isOffered = false,
  isWorker = false,
  logoUrl,
  name,
  notifications,
  notificationMessage,
  onAskToChangeWorker,
  onConfirmFiles,
  onChooseDraftFiles,
  onDeleteFiles,
  onDownloadFiles,
  onNotifyCustomer,
  onUploadFiles,
  orderId,
  orderPrice,
  orderState,
  outtakesMode,
  selectedWorkerName,
  serviceId,
  type,
  uploadedFiles,
}) => {
  const navigate = useNavigate();

  const [logoParams, setLogoParams] = useState<LogoParams>();
  const [useSmallSize, setUseSmallSize] = useState<boolean>(false);
  const [useMediumSize, setUseMediumSize] = useState<boolean>(false);
  const [useFullSize, setUseFullSize] = useState<boolean>(false);

  const [selectedPhotoFiles, setSelectedPhotoFiles] = useState<string[]>([]);

  const accordionState = 'open';

  const handleChangeWorker = (serviceIdInput: string) => {
    onAskToChangeWorker?.(serviceIdInput);
  }

  const handleConfirmFiles = async (serviceIdInput: string, files: string[], isDraft : boolean) => {
     await onConfirmFiles?.(serviceIdInput, files, isDraft);
  }

  const handleDeleteFiles = async (serviceIdInput: string, files: string[], isDraft : boolean) => {
    await onDeleteFiles?.(serviceIdInput, files, isOffered, isDraft);
  }

  const handleDownloadFiles = (serviceIdInput: string, files: string[], isDraft : boolean, ) => {
    const resolutions : string[] = [];
    useSmallSize && resolutions.push('smallSize');
    useMediumSize && resolutions.push('mediumSize');
    useFullSize && resolutions.push('fullSize');

    onDownloadFiles(serviceIdInput, files.length > 0 ? files : selectedPhotoFiles, isDraft, resolutions, logoParams);
  };

  const handleUploadFiles =async (serviceIdInput: string, files: File[], isDraft : boolean) => {
    await onUploadFiles?.(serviceIdInput, files, isDraft);
  }

  const handleResolutionsChange = (size: string, checked: boolean) => {
    switch(size)
    {
      case 'smallSize':
        setUseSmallSize(checked);
        break;
      case 'mediumSize':
        setUseMediumSize(checked);
        break;
      case 'fullSize':
        setUseFullSize(checked);
        break;
    }
  }

  const handleLogoParamsChange = (nlogoParams: LogoParams) => {
    setLogoParams(nlogoParams);
  }

  const handleNewVirtualStaging = () => {
    sessionStorage.setItem('vsPhotos', JSON.stringify(selectedPhotoFiles));
    navigate(`/order-new/brid=${branchId}/pkgid=10470/baseorderid=${orderId}`);
  };

  const handleNewImagemoptionVideo = () => {
    sessionStorage.setItem('vsPhotos', JSON.stringify(selectedPhotoFiles));
    navigate(`/order-new/brid=${branchId}/pkgid=11166/baseorderid=${orderId}`);
  };

  const selectedFiles = uploadedFiles.filter(f => f.fileStatus === 1);
  const additionalFiles = uploadedFiles.filter(f => f.fileStatus !== 1);
  const remainingCount = (amount || 0) - selectedFiles.length;

  return (
    <Card>
        <Accordion
          header={<HeadingIcon icon="services" mb={`${DESKTOP_SPACING.XXL}px`} title={`${name} ${amount ? " X" + amount : ""}`} />}
          showArrow
          state={accordionState}
        >
         { isAdmin &&  <OrderServiceHeader
                name={name}
                notificationMessage={notificationMessage}
                notifications={notifications}
                onAskToChangeWorker={handleChangeWorker}
                onNotifyCustomer={onNotifyCustomer}
                selectedWorkerName={selectedWorkerName}
                serviceId={serviceId}
                type={type} /> }

          {!outtakesMode && !isWorker && <PhotoUploader
            amount={amount}
            files={ orderState === ORDER_STATE.CONTENT_SELECTED ? selectedFiles : uploadedFiles}
            isAdmin = {isAdmin}
            isDraft = {false}
            notifications={notifications}
            onConfirmFiles={handleConfirmFiles}
            onDeleteFiles={handleDeleteFiles}
            onDownloadFiles={handleDownloadFiles}
            onSetSelectedFiles={setSelectedPhotoFiles}
            onUploadFiles={handleUploadFiles}
            orderPrice={orderPrice}
            orderState={orderState}
            serviceId={serviceId} /> }

          {/* { orderState === ORDER_STATE.CONTENT_SELECTED && !isWorker && <PhotoWatermark
            logoUrl={logoUrl}
            onResolutionsChange={handleResolutionsChange}
            onlogoParamsChange={handleLogoParamsChange}
            onNewImagemoptionVideo={handleNewImagemoptionVideo}
            onNewVirtualStaging={handleNewVirtualStaging}
            showNewVirtualOrder={(selectedPhotoFiles?.length || 0) > 0}
            useLogo={useLogo}
          /> } */}

          { orderState === ORDER_STATE.CONTENT_SELECTED && !isWorker && <Watermark
            hasLogo={hasLogo}
            hasSelectedFiles={selectedPhotoFiles.length > 0} 
            logoUrl={logoUrl}
            onResolutionsChange={handleResolutionsChange}
            onlogoParamsChange={handleLogoParamsChange}
            onNewImagemoptionVideo={handleNewImagemoptionVideo}
            onNewVirtualStaging={handleNewVirtualStaging}
            showNewVirtualOrder={(selectedPhotoFiles?.length || 0) > 0}
          /> }
          {/* { orderState === ORDER_STATE.CONTENT_SELECTED && !useLogo && (selectedPhotoFiles?.length || 0) > 0  &&
            <div className="upsell-container">
              <NewVirtualOrders onNewImagemoptionVideo={handleNewImagemoptionVideo} onNewVirtualStaging={handleNewVirtualStaging} />
            </div> 
          } */}

          { orderState === ORDER_STATE.CONTENT_SELECTED && !isWorker && <PhotoUploader
            amount={remainingCount}
            originalAmount={amount}
            files={additionalFiles}
            isAdditional = {true}
            isAdmin = {isAdmin}
            isDraft = {false}
            title="Additional Photos"
            notifications={notifications}
            onChooseDraftFiles={onChooseDraftFiles}
            onConfirmFiles={handleConfirmFiles}
            onDeleteFiles={handleDeleteFiles}
            onDownloadFiles={handleDownloadFiles}
            onUploadFiles={handleUploadFiles}
            orderPrice={orderPrice}
            orderState={orderState}
            outtakesMode={outtakesMode}
            serviceId={serviceId}
            /> }

          <PhotoUploader
            files={draftFiles || []}
            isAdmin = {isAdmin}
            isDraft = {true}
            isWorker= {isWorker}
            title="Outtakes"
            notifications={notifications}
            onChooseDraftFiles={onChooseDraftFiles}
            onDeleteFiles={handleDeleteFiles}
            onDownloadFiles={handleDownloadFiles}
            onUploadFiles={handleUploadFiles}
            orderPrice={orderPrice}
            orderState={orderState}
            outtakesMode={outtakesMode}
            serviceId={serviceId}
            />

      </Accordion>
     </Card>
  );
};

export default memo(Photo);